const LiteLoadingIndicator = ({ color = '#9396a7' }) => (
  <div aria-label="loading" className="dashboard-loading">
    <div className={['lds-ellipsis'].join(' ')}>
      <div style={{ background: color }}></div>
      <div style={{ background: color }}></div>
      <div style={{ background: color }}></div>
      <div style={{ background: color }}></div>
    </div>
  </div>
)

export default LiteLoadingIndicator
